import { render, staticRenderFns } from "./ex-topic-pro.vue?vue&type=template&id=d83b7b56&scoped=true&"
import script from "./ex-topic-pro.vue?vue&type=script&lang=js&"
export * from "./ex-topic-pro.vue?vue&type=script&lang=js&"
import style0 from "./ex-topic-pro.vue?vue&type=style&index=0&id=d83b7b56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83b7b56",
  null
  
)

export default component.exports